import { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
	COOKIE_CONSENT_STORAGE_KEY,
	COOKIE_SETTINGS_EVENT,
	enableAnalytics,
	getCookieConsent,
} from '../core/utils/analyticsConsent'
import styles from '../styles/CookieConsent.module.scss'

const CookieConsent: FC = () => {
	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		const consent = getCookieConsent()
		if (consent === 'accepted') enableAnalytics()
		if (consent === null) setIsVisible(true)

		const openSettings = () => setIsVisible(true)
		window.addEventListener(COOKIE_SETTINGS_EVENT, openSettings)
		return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, openSettings)
	}, [])

	const saveConsent = (accepted: boolean) => {
		const previousConsent = getCookieConsent()
		localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, accepted ? 'accepted' : 'declined')
		setIsVisible(false)

		if (accepted) {
			enableAnalytics()
		} else if (previousConsent === 'accepted') {
			window.location.reload()
		}
	}

	if (!isVisible) return null

	return (
		<section className={styles.banner} role='dialog' aria-label='Настройки cookies' aria-live='polite'>
			<p>
				Мы используем технические данные для работы сайта и, с вашего согласия, Яндекс.Метрику для улучшения
				сервиса. <Link to='/cookies'>Подробнее о cookies</Link>
			</p>
			<div className={styles.actions}>
				<button type='button' className={styles.secondary} onClick={() => saveConsent(false)}>
					Только необходимые
				</button>
				<button type='button' className={styles.primary} onClick={() => saveConsent(true)}>
					Принять
				</button>
			</div>
		</section>
	)
}

export default CookieConsent
